module.exports = __webpack_public_path__ + "img/workshop-title-slide.b0dd20da.png";